import { useEffect } from "react";

const MAX = 4;

const LookProvider = ({ children }) => {
  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduced) return undefined;

    let frame = 0;
    let point = null;

    const apply = () => {
      frame = 0;
      if (!point) return;
      document.querySelectorAll("svg[data-look]").forEach((svg) => {
        const rect = svg.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const angle = Math.atan2(point.y - cy, point.x - cx);
        const distance = Math.min(MAX, Math.hypot(point.x - cx, point.y - cy) / 40);
        svg.style.setProperty("--px", `${Math.cos(angle) * distance}px`);
        svg.style.setProperty("--py", `${Math.sin(angle) * distance}px`);
      });
    };

    const onMove = (event) => {
      point = { x: event.clientX, y: event.clientY };
      if (!frame) frame = window.requestAnimationFrame(apply);
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onMove);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return children;
};

export default LookProvider;
